import * as React from "react"
import { cn } from "../../lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    // Special styling for date and time inputs to fill the full width
    const isDateTimeInput = type === 'date' || type === 'time' || type === 'datetime-local';
    
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-aalaw-red focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          isDateTimeInput && "appearance-none [&::-webkit-date-and-time-value]:text-left [&::-webkit-datetime-edit]:w-full [&::-webkit-datetime-edit-fields-wrapper]:w-full",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }